import { Box, Text, Button } from '@usap/uicomponents'
import styled from 'styled-components'

export const ShopNowContainer = styled(Box)`
  height: 187px;
  margin-top: 10px;

  @media only screen and (min-device-width: 993px) {
    margin: 32px 0 -8px 0;
  }
`

export const ShopNowBox = styled(Box)`
  background: rgb(229, 241, 250);
  position: absolute;
  left: 0;
  width: 100vw;
`

export const ShopNowText = styled(Text)`
  color: rgb(46, 71, 135);
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  line-height: 32px;
  width: 247px;
  margin: 32px auto 0 auto;

  @media only screen and (min-device-width: 414px) {
    width: 100%;
    margin-top: 48px;
  }
`

export const ShopNowButton = styled(Button)`
  padding: 11px 0;
  width: 174px;
  background: rgb(46, 71, 135);
  border-radius: 8px;
  color: rgb(255, 255, 255);
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  margin: 16px auto 40px auto;

  @media only screen and (min-device-width: 414px) {
    margin: 24px auto 48px auto;
  }
`
